const Colors = {
    textColor: '#130F26',
    primaryColor: '#006AE9'
}


export default Colors;